<template>
    <el-container class="page-x" direction="vertical">
        <el-dialog title="核保体检状态轨迹" :visible.sync="statustTrackFlag" center>
            <div class="tableScroll">
                <el-table :data="statusData" border>
                    <el-table-column property="date" label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.targetStatus | targetStatusFilter }}
                        </template>
                    </el-table-column>
                    <el-table-column property="operation" label="操作">
                        <template slot-scope="scope">
                            {{ scope.row.operation | operationFilter }}
                        </template>
                    </el-table-column>
                    <el-table-column property="changeTime" label="时间" width="200"></el-table-column>
                    <el-table-column property="remark" label="备注"></el-table-column>
                </el-table>
            </div>
            
            <div class="footerInfo">取消体检预约共计{{count}}次</div>
        </el-dialog>
    </el-container>
</template>
<script>
    export default{
        data(){
            return {
                loading: false,
                statusData:[],  // 状态轨迹 - 列表
                statustTrackFlag: false, // 状态轨迹 - visible
                count: 0, // 状态轨迹 - 取消体检预约次数
            }
        },
        filters: {
            targetStatusFilter(text) {
                let returnText = {
                    WAIT: "待预约",
                    SUCCESS: "已预约（预约成功）",
                    CHECK: "已到检（体检完成）",
                    LATE: "体检逾期",
                    REPORT: "已出报告（已回销）",
                    LOSE: "已撤销",
                    CANCEL: "预约取消",
                    FINISHED: "已完成",
                    ORDER_CANCEL: "订单取消",
                    EXAM_CANCEL: "到检取消"
                }[text]
                return returnText || text
            },
            operationFilter(text) {
                let returnText = {
                    CREATE_ORDER: "生成订单",
                    BOOKING_EXAM: "预约体检",
                    CANCEL_BOOKING: "取消预约",
                    CANCEL_ORDER: "撤销订单",
                    FINISH_EXAM: "完成体检",
                    OVERDUE_EXAM: "体检逾期",
                    CREATE_REPORT: "报告生成",
                    FINISH_ORDER: "完成订单", 
                }[text]
                return returnText || text
            },
            optionsFilter(text, list) {
                let data = list.find((e) => Number(text) == e.value);
                if (data) return data.label;
                else return '';
            },
        },
        methods: {
            async showDetail(orderId) {
                const res = await this.axios
                    .get(this.getApiUrl('orderLogList'), {
                        params: {
                            orderId
                        },
                    })
                const count = await this.axios
                    .get(this.getApiUrl('orderLogCancelCount'), {
                        params: {
                            orderId
                        },
                    })
                console.log('res', res.data)
                this.statusData = res.data || []
                this.count = count.data || 0
                this.statustTrackFlag = true;
            },
            downloadFile(item){
                let param = {
                    bookingId: item.bookingId,
                };
                let urlPath = this.getApiUrl("orderReportDownload")
                this.$root.exportFile(urlPath,param,"核保体检订单报告",'.pdf')
            },
            toDetail(item) {
                if (item.reportSource) {
                    this.$router.push({
                        name: "ReportDetail",
                        query: {
                            id: item.bookingId,
                            orderNo: item.orderNo,
                            reportSource: item.reportSource,
                            pathSource: '服务订单,核保体检订单,订单报告详情'
                        },
                    });
                } else {
                    this.$message({
                        type: "warning",
                        message: "暂不支持此类型报告",
                    });
                }
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .tableScroll {
        height: 400px;
        overflow-y:scroll;
    }
    .footerInfo {
        margin-top: 30px;
    }
    .search-x{
        min-height: 120px;
        flex-shrink: 0;
        .search-item{
          span{
            display: inline-block;
            width: 100px;
            text-align: right;
          }
        }
    }
    .cont-x{
        flex:1;
        flex-shrink: 0;
    }
</style>
